var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "82bf066bfe54bb9f75bb1bd777e38859a3c1cdb0"
};